export default "__VITE_PUBLIC_ASSET__f65d580e__"